@if (viewModel$ | async; as viewData) {

    <div class="container">
        <div class="container">

            <div class="header">
                <div class="back-link">
                    <a [routerLink]="['/data-lookup/student']" [state]="state"><mat-icon>arrow_back</mat-icon> Back to Student List</a>
                </div>
                <div class="buttons">
                    <app-additional-info
                        [additionalInfoFields]="additionalInfoFields"
                        [contextKey]="additionalInfoContextKey"
                        (fieldSelected)="onFieldSelected($event)" />
                    <button tdoe-button size="large" (click)="export(viewData.student.studentId!, viewData.studentCategories)">Export</button>
                </div>
            </div>

            <div class="mat-accordion">

                <mat-expansion-panel *ngIf="viewData.student as student" expanded hideToggle disabled>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            Student Personal Info
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="data-list">
                        <div class="field">
                            <span class="name">Last Name</span>
                            <span class="value">{{student.nameLast}}</span>
                        </div>
                        <div class="field">
                            <span class="name">First Name</span>
                            <span class="value">{{student.nameFirst}}</span>
                        </div>
                        <div class="field">
                            <span class="name">Middle Name</span>
                            <span class="value">{{student.nameMiddle}}</span>
                        </div>
                        <div class="field">
                            <span class="name">SSID</span>
                            <span class="value">{{student.ssid}}</span>
                        </div>
                        <div class="field">
                            <span class="name">EdFi ID</span>
                            <span class="value">{{student.stateStudentId}}</span>
                        </div>
                        <div class="field">
                            <span class="name">Grade</span>
                            <span class="value">{{student.grade}}</span>
                        </div>
                        <div class="field">
                            <span class="name">District</span>
                            <span class="value">{{student.district}}</span>
                        </div>
                        <div class="field">
                            <span class="name">Service District</span>
                            <span class="value">{{student.serviceDistrict ?? '--'}}</span>
                        </div>
                        <div class="field">
                            <span class="name">School</span>
                            <span class="value">{{student.school}}</span>
                        </div>
                        <div class="field">
                            <span class="name">Service School</span>
                            <span class="value">{{student.serviceSchool ?? '--'}}</span>
                        </div>
                        <div class="field">
                            <span class="name">Student Standard Day (Minutes)</span>
                            <span class="value">{{student.standardDayMinutes ?? '--'}}</span>
                        </div>
                        <div class="field">
                            <span class="name">Service Type</span>
                            <span class="value">{{student.serviceType}}</span>
                        </div>
                        <div class="field">
                            <span class="name">Withdrawal End Date</span>
                            <span class="value">{{student.withdrawalEndDate == '1900-01-01' ? '--' : student.withdrawalEndDate}}</span>
                        </div>
                        <div class="field">
                            <span class="name">Withdrawal Code</span>
                            <span class="value">{{student.withdrawalCode}}</span>
                        </div>
                        <div class="field">
                            <span class="name">Gender</span>
                            <span class="value">{{student.gender}}</span>
                        </div>
                    </div>
                </mat-expansion-panel>

                @if (viewData.visibleCategories.activeEnrollment) {

                    @if (activeEnrollmentVM$ | async; as vm) {

                        <mat-expansion-panel>
                            <mat-expansion-panel-header>

                                <mat-panel-title>
                                <span>Current Enrollment (</span>
                                <span [innerText]="vm.length | number"></span>
                                <span>)</span>
                                </mat-panel-title>

                            </mat-expansion-panel-header>
                            <div class="scrollinator">

                                <mat-table [dataSource]="vm ?? []">

                                    @for (col of viewData.visibleCategories.activeEnrollment.fields;track col) {

                                        <ng-container [matColumnDef]="strip(col.key)">
                                            <mat-header-cell *matHeaderCellDef>{{ col.name }}</mat-header-cell>
                                            <mat-cell *matCellDef="let item">
                                                {{ (item | nestedProperty: strip(col.key)) ?? '--' }}
                                            </mat-cell>
                                        </ng-container>

                                    }

                                    <mat-header-row *matHeaderRowDef="viewData.displayedColumns.activeEnrollment"/>
                                    <mat-row *matRowDef="let row;columns: viewData.displayedColumns.activeEnrollment" />
                                    
                                    <tr class="mat-row no-data" *matNoDataRow>
                                        <td class="mat-cell" [attr.colspan]="viewData.displayedColumns.activeEnrollment?.length">No staff data</td>
                                    </tr>
                                </mat-table>

                            </div>
                        </mat-expansion-panel>

                    } @else {

                        <mat-expansion-panel>
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    <span>Current Enrollment (Loading...)</span>
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                                <div class="sub-section">
                                    <ngx-skeleton-loader appearance="line" count="10"></ngx-skeleton-loader>
                                </div>
                        </mat-expansion-panel>

                    }

                }
                
                @if (viewData.visibleCategories.attendance) {

                    @if (attendanceVM$ | async; as vm) {

                        <mat-expansion-panel>
                            <mat-expansion-panel-header>

                                <mat-panel-title>
                                    <span>Attendance (</span>
                                    <span [innerText]="vm.data?.length | number"></span>
                                    <span>)</span>
                                </mat-panel-title>

                            </mat-expansion-panel-header>
                            <div class="scrollinator">

                                <mat-table [dataSource]="vm.data ?? []">

                                    @for (col of viewData.visibleCategories.attendance.fields;track col) {

                                        <ng-container [matColumnDef]="strip(col.key)">
                                            <mat-header-cell *matHeaderCellDef>{{ col.name }}</mat-header-cell>
                                            <mat-cell *matCellDef="let item">
                                                {{ (item | nestedProperty: strip(col.key)) ?? '--' }}
                                            </mat-cell>
                                        </ng-container>

                                    }

                                    <mat-header-row *matHeaderRowDef="viewData.displayedColumns.attendance"/>
                                    <mat-row *matRowDef="let row;columns: viewData.displayedColumns.attendance" />
                                    
                                    <tr class="mat-row no-data" *matNoDataRow>
                                        <td class="mat-cell" [attr.colspan]="viewData.displayedColumns.attendance?.length">No attendance data</td>
                                    </tr>
                                </mat-table>

                            </div>
                        </mat-expansion-panel>

                    } @else {

                        <mat-expansion-panel>
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    <span>Attendance (Loading...)</span>
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                                <div class="sub-section">
                                    <ngx-skeleton-loader appearance="line" count="10"></ngx-skeleton-loader>
                                </div>
                        </mat-expansion-panel>

                    }

                }
                                
                @if (viewData.visibleCategories.clubMemberships) {

                    @if (clubMembershipVM$ | async; as vm) {

                        <mat-expansion-panel>
                            <mat-expansion-panel-header>

                                <mat-panel-title>
                                <span>Club Memberships (</span>
                                <span [innerText]="vm.length| number"></span>
                                <span>)</span>
                                </mat-panel-title>

                            </mat-expansion-panel-header>
                            <div class="scrollinator">

                                <mat-table [dataSource]="vm ?? []">

                                    @for (col of viewData.visibleCategories.clubMemberships.fields;track col) {

                                        <ng-container [matColumnDef]="strip(col.key)">
                                            <mat-header-cell *matHeaderCellDef>{{ col.name }}</mat-header-cell>
                                            <mat-cell *matCellDef="let item">
                                                {{ (item | nestedProperty: strip(col.key)) ?? '--' }}
                                            </mat-cell>
                                        </ng-container>

                                    }

                                    <mat-header-row *matHeaderRowDef="viewData.displayedColumns.clubMemberships"/>
                                    <mat-row *matRowDef="let row;columns: viewData.displayedColumns.clubMemberships" />
                                    
                                    <tr class="mat-row no-data" *matNoDataRow>
                                        <td class="mat-cell" [attr.colspan]="viewData.displayedColumns.clubMemberships?.length">No club membership data</td>
                                    </tr>
                                </mat-table>

                            </div>
                        </mat-expansion-panel>

                    } @else {

                        <mat-expansion-panel>
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    <span>Club Memberships (Loading...)</span>
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                                <div class="sub-section">
                                    <ngx-skeleton-loader appearance="line" count="10"></ngx-skeleton-loader>
                                </div>
                        </mat-expansion-panel>

                    }

                }
                                                
                @if (viewData.visibleCategories.disciplinaryActions) {

                    @if (disciplinaryActionsVM$ | async; as vm) {

                        <mat-expansion-panel>
                            <mat-expansion-panel-header>

                                <mat-panel-title>
                                <span>Disciplinary Actions (</span>
                                <span [innerText]="vm.length| number"></span>
                                <span>)</span>
                                </mat-panel-title>

                            </mat-expansion-panel-header>
                            <div class="scrollinator">

                                <mat-table [dataSource]="vm ?? []">

                                    @for (col of viewData.visibleCategories.disciplinaryActions.fields;track col) {

                                        <ng-container [matColumnDef]="strip(col.key)">
                                            <mat-header-cell *matHeaderCellDef>{{ col.name }}</mat-header-cell>
                                            <mat-cell *matCellDef="let item">
                                                {{ (item | nestedProperty: strip(col.key)) ?? '--' }}
                                            </mat-cell>
                                        </ng-container>

                                    }

                                    <mat-header-row *matHeaderRowDef="viewData.displayedColumns.disciplinaryActions"/>
                                    <mat-row *matRowDef="let row;columns: viewData.displayedColumns.disciplinaryActions" />
                                    
                                    <tr class="mat-row no-data" *matNoDataRow>
                                        <td class="mat-cell" [attr.colspan]="viewData.displayedColumns.disciplinaryActions?.length">No disciplinary action data</td>
                                    </tr>
                                </mat-table>

                            </div>
                        </mat-expansion-panel>

                    } @else {

                        <mat-expansion-panel>
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    <span>Disciplinary Actions (Loading...)</span>
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                                <div class="sub-section">
                                    <ngx-skeleton-loader appearance="line" count="10"></ngx-skeleton-loader>
                                </div>
                        </mat-expansion-panel>

                    }

                }
                
                @if (viewData.visibleCategories.finalGrades) {

                    @if (finalGradesVM$ | async; as vm) {

                        <mat-expansion-panel>
                            <mat-expansion-panel-header>

                                <mat-panel-title>
                                <span>Final Grades (</span>
                                <span [innerText]="vm.length| number"></span>
                                <span>)</span>
                                </mat-panel-title>

                            </mat-expansion-panel-header>
                            <div class="scrollinator">

                                <mat-table [dataSource]="vm ?? []">

                                    @for (col of viewData.visibleCategories.finalGrades.fields;track col) {

                                        <ng-container [matColumnDef]="strip(col.key)">
                                            <mat-header-cell *matHeaderCellDef>{{ col.name }}</mat-header-cell>
                                            <mat-cell *matCellDef="let item">
                                                {{ (item | nestedProperty: strip(col.key)) ?? '--' }}
                                            </mat-cell>
                                        </ng-container>

                                    }

                                    <mat-header-row *matHeaderRowDef="viewData.displayedColumns.finalGrades"/>
                                    <mat-row *matRowDef="let row;columns: viewData.displayedColumns.finalGrades" />
                                    
                                    <tr class="mat-row no-data" *matNoDataRow>
                                        <td class="mat-cell" [attr.colspan]="viewData.displayedColumns.finalGrades?.length">No final grade data</td>
                                    </tr>
                                </mat-table>

                            </div>
                        </mat-expansion-panel>

                    } @else {

                        <mat-expansion-panel>
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    <span>Final Grades (Loading...)</span>
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                                <div class="sub-section">
                                    <ngx-skeleton-loader appearance="line" count="10"></ngx-skeleton-loader>
                                </div>
                        </mat-expansion-panel>

                    }

                }
                
                @for (category of viewData.staticSections;track category) {

                    <mat-expansion-panel>

                        <mat-expansion-panel-header>

                            @if (category.isArray) {

                                @if (getArrayData(viewData.student, category.dataPath)) {

                                    <mat-panel-title>
                                        {{ category.name }} ({{ getArrayData(viewData.student, category.dataPath)?.length ?? 0 }})
                                    </mat-panel-title>

                                } @else {

                                    <mat-panel-title>
                                        {{ category.name }} (Loading...)
                                    </mat-panel-title>

                                }

                            } @else {

                                <mat-panel-title>
                                    {{ category.name }}
                                </mat-panel-title>

                            }


                        </mat-expansion-panel-header>

                        @if (category.notImplemented) {
                            
                            <tdoe-alert class="blanco" style="margin-top:20px;display:block;" [persistent]="true">No data available</tdoe-alert>

                        } @else if (category.isArray) {

                            <div class="sub-section">

                                <div class="scrollinator">

                                    @if (getArrayData(viewData.student, category.dataPath); as arrayData) {

                                        @if (arrayData) {

                                            <mat-table [dataSource]="arrayData">
                                                <ng-container *ngFor="let col of category.fields" [matColumnDef]="strip(col.key)">
                                                    <mat-header-cell *matHeaderCellDef>{{ col.name }}</mat-header-cell>
                                                    <mat-cell *matCellDef="let item">
                                                        {{ item | nestedProperty: strip(col.key) }}
                                                    </mat-cell>
                                                </ng-container>

                                                <mat-header-row *matHeaderRowDef="viewData.tableColumns[category.name]">
                                                </mat-header-row>
                                                <mat-row
                                                *matRowDef="let row; columns: viewData.tableColumns[category.name]">
                                                </mat-row>

                                                <tr class="mat-row" *matNoDataRow>
                                                <td class="mat-cell" colspan="4">
                                                    No {{ category.name | lowercase }} found
                                                    for '{{ viewData.student.nameLast }} {{ viewData.student.nameFirst }}'
                                                </td>
                                                </tr>
                                            </mat-table>

                                        } @else {

                                            <ngx-skeleton-loader appearance="line" count="9"></ngx-skeleton-loader>

                                        }

                                    }

                                </div>

                            </div>

                        } @else {

                            <div class="sub-section">
                                <div class="data-list">
                                <div class="field" *ngFor="let field of category.fields">
                                    <span class="name">{{ field.name }}</span>
                                    <span class="value">
                                        @if (field.jsonPath) {
                                            {{ viewData.student | jsonPath: field.jsonPath: '--' }}
                                        } @else {
                                            {{ viewData.student| nestedProperty: strip(category.dataPath ? category.dataPath + '.' + field.key : field.key) }}
                                        }
                                    </span>
                                </div>
                                </div>
                            </div>

                        }

                    </mat-expansion-panel>

                }

            </div>

        </div>
    </div>
} @else {

    <div style="width: 80%; margin: 5% auto;">
        <ngx-skeleton-loader appearance="line" count="10"></ngx-skeleton-loader>
    </div>
    
}
